let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ei2lH")).then(() => parcelRequire('246GD'));